import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreLoginComponent } from 'src/views/pre-login/pre-login.component';

const routes: Routes = [
  { path: 'pre-login', component: PreLoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class PreLoginRoutingModule { }
